"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { getBuilderModelName } from "@/libs/builder/tools/getBuilderModelName";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export type FaqResultsContainerProps = BuilderComponentProps<typeof faqResultsContainerInputs>;

export const faqResultsContainerInputs = [
  {
    name: "sidebar",
    type: "reference",
    model: getBuilderModelName("faq-sidebar"),
  },
  {
    name: "searchbar",
    type: "reference",
    model: getBuilderModelName("faq-search"),
  },
] as const satisfies Inputs;

const FaqResultsContainer = dynamic(async () =>
  withValidation(
    faqResultsContainerInputs,
    (await import("./FaqResultsContainer")).FaqResultsContainer,
    "FaqResultsContainer"
  )
);
export const FaqResultsContainerComponent: RegisteredComponent = {
  name: "FaqResultsContainer",
  component: FaqResultsContainer,
  inputs: faqResultsContainerInputs,
  canHaveChildren: true,
};
